module.exports = __webpack_public_path__ + "img/1.0748c157.png";